import { useMemo } from 'react';

import { useVehiclesListQuery } from 'src/common/external/bambi-api/bambiApi';

import { CredentialCategory } from '../types';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export function useVehicleOptions(category: CredentialCategory) {
  const { data, isLoading, error } = useVehiclesListQuery(
    {},
    {
      skip: category === 'Misc' || category === 'Team',
    }
  );

  const options = useMemo<SelectOption[]>(
    () =>
      data?.results.map((vehicle) => ({
        value: vehicle.id,
        label: vehicle.nickname || '',
      })) ?? [],
    [data]
  );

  return {
    options,
    isLoading,
    error,
  };
}
